import { CartProvider } from "../context/CartContext";
import { AuthProvider } from "../context/AuthContext";

export default function Providers({ children }) {
  return (
    <AuthProvider>
      <CartProvider>
        {children}
      </CartProvider>
    </AuthProvider>
  );
}
